<template>
  <TeamInvitation
    :title="title"
    @send-invites="sendInvites"
  />
</template>

<script>
import CompanyService from "@/services/CompanyService"
import TeamInvitation from "@/components/ri3/project/TeamInvitation.vue"

export default {
  name: "TeamCompanyInvitation",
  components: { TeamInvitation },
  computed: {
    title() {
      return this.$t("views.team.invite_join", {
        entity: this.$t("categories.company.name").toLowerCase()
      })
    }
  },
  methods: {
    sendInvites(invites) {
      const companyId = this.$store.state.app.company.pk
      CompanyService.sendInvite(this, companyId, invites)
    }
  }
}
</script>
